<template>
    <div class="overflow-wrapper">
        <div v-if="isEditor || isAdmin" class="margin-bottom-20">
            <button @click="edit(-1)">Nová zakázka</button>
        </div>

        <div class="overflow-container">        
            <div style="display: flex; align-items: flex-start;">
                <EditZakazka
                    v-if="showEdit"
                    :itemId="itemId"
                    :isAdmin="isAdmin"
                    @close="closeEdit"
                    @updateTable="updateTable"
                    class="margin-bottom-20 border padding-10"
                />
            </div>

            <div>
                <h3>Aktivní</h3>
                <table>
                    <thead>
                        <tr>
                            <th v-for="(v, k) in headers" :key="k" @click="sort(k)">{{ v }}</th>
                            <th v-if="isEditor || isAdmin || sortedRows.filter(r => r.stav == 0 && r['idEditor'] == idUser).length > 0"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, i) in sortedRows.filter(r => r.stav == 0)" :key="i">
                            <td
                                v-for="(header, j) in headerKeys"
                                :key="j"
                                @click="!this.isProjektant ? gotoPodani(row['id']) : gotoStanoviska(row['id'])"
                            >
                                {{ row[header] }}
                            </td>
                            <td v-if="isEditor || isAdmin || (idUser == row['idEditor'])"><span @click="edit(row['id'])" class="selectListButton">Editace</span></td>
                            <td v-if="!(isEditor || isAdmin || (idUser == row['idEditor'])) && sortedRows.filter(r => r['idEditor'] == idUser).length > 0">&nbsp;</td>
                        </tr>
                    </tbody>
                </table>
                
                <h3 style="margin-top: 50px;">Neaktivní</h3>
                <table>
                    <thead>
                        <tr>
                            <th v-for="(v, k) in headers" :key="k" @click="sort(k)">{{ v }}</th>
                            <th v-if="isEditor || isAdmin || sortedRows.filter(r => r.stav == 1 && r['idEditor'] == idUser).length > 0"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, i) in sortedRows.filter(r => r.stav == 1)" :key="i">
                            <td
                                v-for="(header, j) in headerKeys"
                                :key="j"
                                @click="!this.isProjektant ? gotoPodani(row['id']) : gotoStanoviska(row['id'])"
                            >
                                {{ row[header] }}
                            </td>
                            <td v-if="isEditor || isAdmin || (idUser == row['idEditor'])"><span @click="edit(row['id'])" class="selectListButton">Editace</span></td>
                        </tr>
                    </tbody>
                </table>
                
                <h3 style="margin-top: 50px;">Archivované</h3>
                <table>
                    <thead>
                        <tr>
                            <th v-for="(v, k) in headers" :key="k" @click="sort(k)">{{ v }}</th>
                            <th v-if="isAdmin"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, i) in sortedRows.filter(r => r.stav == 2)" :key="i">
                            <td
                                v-for="(header, j) in headerKeys"
                                :key="j"
                                @click="!this.isProjektant ? gotoPodani(row['id']) : gotoStanoviska(row['id'])"
                            >
                                {{ row[header] }}
                            </td>
                            <td v-if="isAdmin"><span @click="edit(row['id'])" class="selectListButton">Editace</span></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '@/api/api.js'
    import EditZakazka from './EditZakazka.vue'

    export default {
        name: 'Zakazka',
        props: ['isEditor', 'isAdmin', 'isManager', 'isProjektant', 'idUser'],
        components: {
            EditZakazka
        },
        data() {
            return {
                headers: {},
                rows: [],
                currentSort: '',
                currentSortDir: 'asc',
                showEdit: false,
                itemId: -1
            }
        },
        computed: {
            headerKeys() {
                return Object.keys(this.headers)
            },
            sortedRows() {
                if (this.currentSort === '')
                    return this.rows
                return this.rows.slice().sort(
                    (a, b) => this.currentSortDir === 'desc' 
                        ? b[this.currentSort].localeCompare(a[this.currentSort], 'cz') 
                        : a[this.currentSort].localeCompare(b[this.currentSort], 'cz'))
            }
        },
        methods: {
            updateTable() {
                this.headers = { "cisloZakazky": "Číslo", "nazev": "Název", "investor": "Investor", "manazer": "Manažer" }
                this.$progress.start()
                if (this.isEditor || this.isAdmin || this.isManager) {
                    api.getZakazka()
                    .then(response => {
                        this.rows = response.data
                    })
                    .catch(error => {
                        console.log('Error: ', error)
                    })
                }
                else if (this.isProjektant) {
                    api.getZakazkaForProjektant(this.idUser)
                    .then(response => {
                        this.rows = response.data
                    })
                    .catch(error => {
                        console.log('Error: ', error)
                    })
                }
                else {
                    api.getZakazkaForUser(this.idUser)
                    .then(response => {
                        this.rows = response.data
                    })
                    .catch(error => {
                        console.log('Error: ', error)
                    })
                }
                this.$progress.finish()
            },
            sort(s) {
                if (s === this.currentSort) {
                    this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
                }
                else {
                    this.currentSort = s
                    this.currentSortDir = 'asc'
                }
            },
            edit(id) {
                this.itemId = id
                this.showEdit = true
            },
            closeEdit() {
                this.showEdit = false
                this.itemId = -1
            },
            gotoPodani(idzakazka) {
                this.$emit('gotoPodani', idzakazka)
            },
            gotoStanoviska(idzakazka) {
                this.$emit('gotoStanoviska', idzakazka)
            }
        },
        created() {
            this.showEdit = false
            this.updateTable()
        }
    }
</script>